export default __webpack_public_path__ + "static/media/hacksaw.95dcd0c2.png";